import { Flex } from '@rebass/grid';
import { css, styled } from 'styles';

export const Container = styled(Flex)`
  background: #191919;
  border-radius: 4px;
  padding: 15px;
  min-height: 127px;
  line-height: 1;

  h1 {
    font-size: 2rem;
    font-weight: 600;
    margin-top: 2px;

    span {
      font-weight: 500;
      opacity: 0.5;
      font-size: 0.8em;
      text-transform: uppercase;
    }
  }

  h2 {
    font-size: 2.8rem;
    margin-top: 6px;
  }
`;

export const IconWrapper = styled.div`
  padding-right: 16px;
`;

export const PriceDiff = styled.div`
  display: flex;
  font-size: 1.4rem;
  margin-top: 10px;
`;

export const PercentageValue = styled.span<{ percent: number }>`
  display: flex;

  svg {
    margin-left: -2px;
    margin-right: 3px;
    margin-bottom: -2px;
  }

  ${({ percent }) =>
    percent > 0 &&
    css`
      color: #00b96c;
    `}

  ${({ percent }) =>
    percent < 0 &&
    css`
      color: #e81732;
    `}
`;

export const AbsoluteChange = styled.span`
  color: #fff;
  opacity: 0.5;
  margin-left: 5px;
`;
